import BnSnStocksPage from "./BnSnStocksPage";

export default function BnStocks() {
  return (
    <BnSnStocksPage
      desk="bn"
      title="BANKNIFTY STOCKS MARKET REACTION"
      gridTitle="Live BankNifty Weightage Grid"
      activeTab="banknifty"
    />
  );
}
